import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import request from '../utils/request';



//  fetch rfq details data
export const fetchRfqDetails = async (rfqId = '') => {
  if (!rfqId) {
    throw new Error('RFQ ID is required');
  }
  const response = await request({
    url: 'rfq/getRfqDetails',
    method: 'post',
    data: {
      rfqId: rfqId
    }
  });
  return response.rfq;
}


const rfqDataSlice = createSlice({
  name: 'rfqData',
  initialState: {
    rfqDetails: {
      data: [],
      status: 'idle',
      error: null,
    },
    sumInsuredData: {
      data: [],
      status: 'idle',
      error: null,
    }
    , premiumTotalRefetch: false,
    dataListSectionIds: [],
    endorsementScreenNumber: 1,
    selectedPolicyDetails: null,
    endorsementFormData: {
      customerData: null,
      riskDescription: null,
      suggestedDeductible: null,
      hypothetical_details: [],
      warrantiesExclusions: null,
      clauseRemark: null,
      coverageRemark: null,
      dynamicFormData: null,
      secondDynamicFormData: null,
      thirdDynamicFormData: null,
      sumInsuredSectionData: [],
      extended_policy:'',
      cancellation_Endorsement:''
    }

  },
  reducers: {
    // Reducer to handle pending state
    setLoading: (state, action) => {
      const { dataType } = action.payload; // dataType can be 'vehicleType', 'machineType', or 'assetType'
      state[dataType].status = 'loading';
    },
    // Reducer to handle fulfilled state
    setDataSuccess: (state, action) => {
      const { dataType, data } = action.payload; // dataType is 'vehicleType', 'machineType', 'assetType'

      state[dataType].status = 'success';
      state[dataType].data = data;
      state[dataType].error = null;

    },
    updateSumInsuredSectionData: (state, action) => {
      console.log("action.payload", action.payload);

      const newSections = action.payload.sumInsuredSectionData || {};
      const existingSections = state.endorsementFormData.sumInsuredSectionData || {};
      const mergedSections = { ...existingSections };

      // 🔹 Helper: check if a group has excel data
      const hasExcelKeys = (group) => {
        return (
          group?.excelPathForInsert ||
          group?.excelInsertSummary ||
          group?.excelPathForDelete ||
          group?.excelDeleteSummary
        );
      };

      Object.keys(newSections).forEach((sectionId) => {
        const newSection = newSections[sectionId];
        const sectionType = newSection?.sectionType;

        if (sectionType === "labelValuePair") {
          const items = newSection?.labelValuePairItem || [];
          if (items.length > 0) {
            mergedSections[sectionId] = {
              sectionType: "labelValuePair",
              labelValuePairItem: items,
              groups: [],
            };
          } else {
            delete mergedSections[sectionId];
          }
        } else {
          const newGroups = newSection?.groups || {};
          const existingGroups = existingSections[sectionId]?.groups || {};
          const mergedGroups = { ...existingGroups };

          Object.keys(newGroups).forEach((groupId) => {
            const updatedGroup = newGroups[groupId];
            const entries = updatedGroup.sumInsuredEntry || [];

            if (entries.length > 0 || hasExcelKeys(updatedGroup)) {
              mergedGroups[groupId] = {
                ...existingGroups[groupId],
                ...updatedGroup,
              };
            } else {
              delete mergedGroups[groupId];
            }
          });

          if (Object.keys(mergedGroups).length > 0) {
            mergedSections[sectionId] = {
              ...existingSections[sectionId],
              ...newSection,
              groups: mergedGroups,
            };
          } else {
            if (!mergedSections[sectionId]?.fireFloaterData) {
              delete mergedSections[sectionId];
            } 

          }
        }
      });


      // ✅ Preserve ALL existing top-level keys of endorsementFormData
      state.endorsementFormData = {
        ...state.endorsementFormData,
        sumInsuredSectionData: mergedSections,
      };
    }

    ,

    updateEndorsementFormData: (state, action) => {
      state.endorsementFormData = {
        ...state.endorsementFormData,
        ...action.payload
      };
    },
    updatePremiumRefetchStatus: (state, action) => {
      state.premiumTotalRefetch = !state.premiumTotalRefetch;

    },
    updateEndorsementScreenNumber: (state, action) => {
      state.endorsementScreenNumber = action.payload
    },
    updateDataListSectionId: (state, action) => {
      state.dataListSectionIds = action.payload.data;

    },
    updateSelectedPolicyDetails: (state, action) => {
      state.selectedPolicyDetails = action.payload;

    },
    // Reducer to handle rejected state
    setDataError: (state, action) => {
      const { dataType, error } = action.payload;
      state[dataType].status = 'failed';
      state[dataType].error = error;
    },
  },
});

export const { setLoading, setDataSuccess, setDataError, updatePremiumRefetchStatus,
  updateDataListSectionId, updateEndorsementFormData, updateSumInsuredSectionData, updateEndorsementScreenNumber, updateSelectedPolicyDetails } = rfqDataSlice.actions;
// Selectors for rfq details
export const selectRfqDetails = (state) => state.rfqData.rfqDetails.data;
export const selectSuminsuredDetails = (state) => state.rfqData.sumInsuredData.data;

export const selectRfqDetailStatus = (state) => state.rfqData.rfqDetails.status;

export const selectRfqDetailError = (state) => state.rfqData.rfqDetails.error;
export const selectPremiumTotalRefetchStatus = (state) => state.rfqData.premiumTotalRefetch;
export const selectDataListSectionIds = (state) => state.rfqData.dataListSectionIds;
export const selectEndorsmentFormData = (state) => state.rfqData.endorsementFormData;
export const selectEndorsmentScreenNumber = (state) => state.rfqData.endorsementScreenNumber;
export const selectPolicyDetails = (state) => state.rfqData.selectedPolicyDetails;

export default rfqDataSlice.reducer;
